import { DefineComponent, FunctionalComponent, ref } from "vue";

const classNames =
{
    container :"labledToggleSwitch__container",
    input: "labledToggleSwitch__input",
    toggle: "labledToggleSwitch__toggle",
    name: "labledToggleSwitch__name",
    selectedName: "labledToggleSwitch__name--selected",
};

type LabledToggleSwitchProps =
{
    CheckedStateLabel: string;
    UncheckedStateLabel: string;
    checked?: boolean;
    id?: string;
    name: string;
    disabled?: boolean;
    onChange?: (e: Event) => void;
};

type LabledToggleSwitchContext =
{
    "update:checked": (checked: boolean) => void;
};

const LabledToggleSwitch: FunctionalComponent<LabledToggleSwitchProps, LabledToggleSwitchContext> = function vButton(props: LabledToggleSwitchProps, context)
{
    const isChecked = ref<boolean>(props.checked ?? false);
    const inputElement = ref<HTMLInputElement>();

    function changeValue(manual: boolean)
    {
        if (props.disabled)
        {
            return;
        }
        if (manual)
        {
            inputElement.value!.checked = !inputElement.value!.checked;
        }
        isChecked.value = inputElement.value!.checked;
        context.emit("update:checked", isChecked.value);
    }

    return (
        <label role="checkbox"
            id={props.id ? `${props.id}_labledToggleSwitch` : undefined}
            tabindex="0"
            class={{ [classNames.container]: true, "ui-control": true, "ui-disabled": props.disabled === true }} {...context.attrs}
            onKeydown={(e: KeyboardEvent) => { if (e.key === "Enter") { changeValue(true); }}}>
            <input ref={inputElement}
                id={props.id}
                class={{ [classNames.input]: true }}
                name={props.name}
                type="checkbox"
                tabindex="-1"
                checked={isChecked.value}
                onChange={() => changeValue(false)} />
            <div class={{ [classNames.toggle]: true }}></div>
            <div class={{ [classNames.name]: true, [classNames.selectedName]: !isChecked.value }}>{props.UncheckedStateLabel}</div>
            <div class={{ [classNames.name]: true, [classNames.selectedName]: isChecked.value }}>{props.CheckedStateLabel}</div>
        </label>
    );
};

export default LabledToggleSwitch as unknown as DefineComponent<LabledToggleSwitchProps, LabledToggleSwitchContext, JSX.Element>;
